const activatedTags = state => state.list.filter(tag => tag.active)
const activatedTagNames = (state, getters) => getters.activatedTags.map(tag => tag.text)

export default {
  activatedTags,
  activatedTagNames
}
